<div [class]="hide() ? 'fading-Out' : ''">
  <div [class]="displayAsOverlay() ? 'overlay-loader' : 'loader'">
    <div [class]="displayAsOverlay() ? 'overlay-inner' : 'inner'">
      <svg xmlns="http://www.w3.org/2000/svg">
        <!-- <rect id="background-root" width="100%" height="100%" style="fill: rgb(255, 255, 255)" /> -->
        <ellipse style="fill: rgb(255, 255, 255)" rx="15" ry="15" cy="50%" cx="50%" />
        <g id="loadingWheel">
          <ellipse style="fill: rgba(37, 37, 37, 0.9)" rx="100" ry="100" cy="0" cx="0" />
          <ellipse style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0)" cx="0" rx="50" ry="50" cy="0" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="0"
            cy="-50"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="35"
            cy="-35"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="35"
            cy="35"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="0"
            cy="50"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="50"
            cy="0"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="-50"
            cy="0"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="-35"
            cy="-35"
            rx="10"
            ry="10" />
          <ellipse
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 0.5px"
            cx="-35"
            cy="35"
            rx="10"
            ry="10" />
        </g>
      </svg>
    </div>
  </div>
</div>
